import React, { useState } from 'react';
import AlbumManager from './AlbumManager';
import UserManagement from './UserManagement';
import TenantPreferences from './TenantPreferences';
import TenantManagement from './TenantManagement';
import ThemeManager from './ThemeManager';
import ChangePassword from './ChangePassword';
import './SettingsPanel.css';

function SettingsPanel({ isOpen, onClose, onAlbumChange, user }) {
    const [activeTab, setActiveTab] = useState('albums');

    if (!isOpen) return null;

    return (
        <div className="settings-overlay" onClick={onClose}>
            <div className="settings-panel" onClick={(e) => e.stopPropagation()}>
                <div className="settings-header">
                    <h2>Settings</h2>
                    <button className="settings-close-btn" onClick={onClose}>&times;</button>
                </div>

                <div className="settings-tabs">
                    <button
                        className={`settings-tab ${activeTab === 'albums' ? 'active' : ''}`}
                        onClick={() => setActiveTab('albums')}
                    >
                        Albums
                    </button>
                    <button
                        className={`settings-tab ${activeTab === 'profile' ? 'active' : ''}`}
                        onClick={() => setActiveTab('profile')}
                    >
                        Profile
                    </button>
                    {user.isSuperuser && (
                        <>
                            <button
                                className={`settings-tab ${activeTab === 'users' ? 'active' : ''}`}
                                onClick={() => setActiveTab('users')}
                            >
                                Users
                            </button>
                            <button
                                className={`settings-tab ${activeTab === 'preferences' ? 'active' : ''}`}
                                onClick={() => setActiveTab('preferences')}
                            >
                                Preferences
                            </button>
                        </>
                    )}
                    {(user.isSuperuser || user.isGlobalAdmin) && (
                        <button
                            className={`settings-tab ${activeTab === 'themes' ? 'active' : ''}`}
                            onClick={() => setActiveTab('themes')}
                        >
                            Themes
                        </button>
                    )}
                    {user.isGlobalAdmin && (
                        <button
                            className={`settings-tab ${activeTab === 'tenants' ? 'active' : ''}`}
                            onClick={() => setActiveTab('tenants')}
                        >
                            Tenants
                        </button>
                    )}
                </div>

                <div className="settings-content">
                    {activeTab === 'albums' && (
                        <AlbumManager
                            isOpen={true}
                            onClose={() => {}}
                            onAlbumChange={onAlbumChange}
                            embedded={true}
                        />
                    )}
                    {activeTab === 'profile' && (
                        <ChangePassword />
                    )}
                    {activeTab === 'users' && user.isSuperuser && (
                        <UserManagement currentUser={user} />
                    )}
                    {activeTab === 'preferences' && user.isSuperuser && (
                        <TenantPreferences />
                    )}
                    {activeTab === 'themes' && (user.isSuperuser || user.isGlobalAdmin) && (
                        <ThemeManager />
                    )}
                    {activeTab === 'tenants' && user.isGlobalAdmin && (
                        <TenantManagement />
                    )}
                </div>
            </div>
        </div>
    );
}

export default SettingsPanel;
